import styled from '@emotion/styled'

import { breakpoints, container, palette, spacing } from 'main/ui'

export const Container = styled.div`
  display: flex;
  background-color: ${palette.white};
  border: 1px solid ${palette.chrome};
  border-radius: 3px;
  box-sizing: border-box;
  flex-direction: row;
  padding: ${spacing.majorScale(4)}px;

  @media (min-width: ${breakpoints.lg}px) {
    // min-width: ${container.maxWidth.lg}px;
    width: ${container.maxWidth.lg}px;
    max-width: 100%;
  }
`

export const ContentContainer = styled.div`
  flex-grow: 1;
`
